import React from 'react'

import {
    Box,
    ButtonV2,
    Dropdown,
    ICONS_NAME,
    IconV2,
    Typography,
} from '@/elements'

import { closestPages, pageSizeOptions } from './constants'
import { COLORS } from '@/constants'

const Pagination = ({
    currentPage,
    totalPages,
    handleChange,
    size,
    totalCount,
}) => {
    // нормализуем значения
    const safeTotalPages = Math.max(1, totalPages || 1)
    const safeCurrentPage = Math.min(
        Math.max(1, currentPage || 1),
        safeTotalPages,
    )
    const safeTotalCount = totalCount ?? 0

    const setCurrentPage = (page) => {
        const nextPage = Math.min(Math.max(1, page), safeTotalPages)

        if (nextPage !== safeCurrentPage) {
            handleChange(nextPage, size)
        }
    }

    const setSizePage = (sizeOption) => {
        handleChange(1, Number(sizeOption.value))
    }

    const pages = []

    for (
        let page = safeCurrentPage - closestPages;
        page <= safeCurrentPage + closestPages;
        page++
    ) {
        if (page <= 1 || page >= safeTotalPages) {
            continue
        }

        pages.push({
            page,
            active: page === safeCurrentPage,
            label: '',
        })
    }

    const startItem = safeTotalCount > 0 ? (safeCurrentPage - 1) * size + 1 : 0

    const endItem =
        safeTotalCount > 0 ? Math.min(safeCurrentPage * size, safeTotalCount) : 0

    return (
        <>
            <Box
                width="100%"
                justify="right"
                align="center"
                $userSelect="none"
                gap="10px"
            >
                <Typography variant="body2">
                    {safeTotalCount
                        ? `${startItem}-${endItem} of ${safeTotalCount}`
                        : '0 of 0'}
                </Typography>

                <Box
                    display="flex"
                    justify="right"
                    align="center"
                    $userSelect="none"
                    gap="10px"
                >
                    <ButtonV2
                        size="small"
                        disabled={safeCurrentPage <= 1}
                        variant="primary"
                        onClick={() => setCurrentPage(safeCurrentPage - 1)}
                    >
                        <IconV2
                            size={8}
                            color={COLORS.grayDark}
                            name={ICONS_NAME.chevronLeft}
                        />
                    </ButtonV2>

                    <ButtonV2
                        disabled={safeCurrentPage >= safeTotalPages}
                        size="small"
                        variant="primary"
                        onClick={() => setCurrentPage(safeCurrentPage + 1)}
                    >
                        <IconV2
                            size={8}
                            color={COLORS.grayDark}
                            name={ICONS_NAME.chevronRight}
                        />
                    </ButtonV2>
                </Box>

                <Typography variant="body2">Rows per page:</Typography>

                <Dropdown onClick={setSizePage} options={pageSizeOptions}>
                    <ButtonV2 variant="primary" size="small" icon={ICONS_NAME.downArrow}>
                        {size}
                    </ButtonV2>
                </Dropdown>
            </Box>
        </>
    )
}

export { Pagination }